
import { CheckCircle, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface BookingResultModalProps {
  isOpen: boolean;
  isSuccess: boolean;
  message: string;
  onClose: () => void;
}

const BookingResultModal = ({ isOpen, isSuccess, message, onClose }: BookingResultModalProps) => {
  const navigate = useNavigate();

  const handleReturnHome = () => {
    onClose();
    navigate('/');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Transparent background overlay */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      
      {/* Modal content */}
      <div className="relative bg-white rounded-lg shadow-xl p-8 max-w-md mx-4 text-center">
        {isSuccess ? (
          <>
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              تم الحجز بنجاح!
            </h3>
            <p className="text-gray-600 mb-6">
              {message || 'تم حجز موعدك بنجاح! سنتواصل معك قريباً.'}
            </p>
            <Button 
              onClick={handleReturnHome}
              className="bg-autocare-blue hover:bg-autocare-blue-light text-white"
            >
              العودة للصفحة الرئيسية
            </Button>
          </>
        ) : (
          <>
            <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-red-600 mb-2">
              فشل الحجز
            </h3>
            <p className="text-red-600 mb-6">
              {message || 'حدث خطأ أثناء الحجز، يرجى المحاولة مرة أخرى.'}
            </p>
            <Button 
              onClick={onClose}
              variant="outline"
              className="border-red-500 text-red-500 hover:bg-red-50"
            >
              حاول مرة أخرى
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingResultModal;
